import { useCssModule, computed } from "vue";
import "./assets/index-CgZzOVq6.js";
import { u as useListeners } from "./assets/index-Ca8wHgNc.js";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useDisabledProp } from "./assets/index-DKxr0Yto.js";
import { u as useHeightProps } from "./assets/index-BWUsUM8p.js";
import { X as XIcon, u as useIconProps } from "./assets/XIcon-U9bwokTN.js";
import { B as BaseLink, u as useLinkProps } from "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-vzP2cezV.js";
import "vue-demi";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { a as modelPropName } from "./assets/SingleInput-CTOYPcHF.js";
import XCheckbox from "./XCheckbox.js";
import XEllipsis from "./XEllipsis.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "@fortawesome/vue-fontawesome";
import "./assets/index-Df_FM1j-.js";
import "./assets/index-BJV0_gaH.js";
import "./BaseOption.js";
import "./XFormField.js";
import "./assets/index-4vIud5LZ.js";
import "./assets/SingleMessage-Dv2wNb7f.js";
import "./XLink.js";
import "./XTooltip.js";
import "./assets/XDropdown-CrQavYks.js";
import "@floating-ui/dom";
import "./BasicContent.js";
import "./ContentBox.js";
import "./CloseButton.js";
import "./AdvancedContent.js";
import "./MessagesContainer.js";
import "./MultipleInputs.js";
const item = "_item_zb7t4_1";
const separator = "_separator_zb7t4_27";
const noClickable = "_noClickable_zb7t4_30";
const isDisabled = "_isDisabled_zb7t4_30";
const selected = "_selected_zb7t4_42";
const data = "_data_zb7t4_46";
const text = "_text_zb7t4_65";
const badge = "_badge_zb7t4_78";
const style0 = {
  item,
  separator,
  noClickable,
  isDisabled,
  selected,
  data,
  text,
  badge
};
const { createIconProps } = useIconProps();
const { createHeightProps, getHeightStyles } = useHeightProps();
const { createDisabledProp, getDisabledClass } = useDisabledProp();
const { createLinkProps } = useLinkProps();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const VALID_TAGS = ["div", "li", "button", "a"];
const __default__ = {
  name: "XListItem",
  components: {
    XCheckbox,
    XIcon,
    BaseLink,
    XEllipsis
  }
};
const _sfc_main = Object.assign(__default__, {
  props: {
    tag: {
      type: String,
      default: "div",
      validation: (tag) => VALID_TAGS.includes(tag)
    },
    active: {
      type: Boolean,
      default: false
    },
    separator: {
      type: Boolean,
      default: false
    },
    checkbox: {
      type: Boolean,
      default: false
    },
    noClickable: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 0
    },
    ellipsis: {
      type: Boolean,
      default: false
    },
    navigable: {
      type: Boolean,
      default: false
    },
    ...createHeightProps({
      height: "40px"
    }),
    ...createIconProps(),
    ...createLinkProps(),
    ...createDisabledProp(),
    ...createTestIdProp()
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const $style = useCssModule();
    const { v2Listeners } = useListeners(["click"]);
    const { formatTestId } = setupTestId(props);
    const { disabledClass } = getDisabledClass(props);
    const { heightStyles } = getHeightStyles(props);
    const isLink = computed(() => props.tag === "a");
    const tagName = computed(() => {
      if (isLink.value) return "BaseLink";
      return props.tag;
    });
    const computedStyle = computed(() => ({
      paddingLeft: `${props.level * 1.6}rem`
    }));
    const tabIndex = computed(() => props.navigable ? 0 : -1);
    const listItemClasses = computed(() => ({
      [$style.separator]: props.separator,
      [$style.selected]: props.active,
      [$style.noClickable]: props.noClickable,
      ...disabledClass.value
    }));
    const listItemCheckboxProps = computed(() => ({
      [modelPropName]: props.active
    }));
    function handleClick(event) {
      if (props.disabled || props.noClickable || props.separator) {
        event.stopPropagation();
        return;
      }
      emit("click", event);
    }
    return { __sfc: true, createIconProps, createHeightProps, getHeightStyles, createDisabledProp, getDisabledClass, createLinkProps, createTestIdProp, setupTestId, VALID_TAGS, props, emit, $style, v2Listeners, formatTestId, disabledClass, heightStyles, isLink, tagName, computedStyle, tabIndex, listItemClasses, listItemCheckboxProps, handleClick, XCheckbox, XIcon, XEllipsis };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.tagName, _vm._g({ tag: "component", class: [_setup.$style.item, _setup.listItemClasses], style: _setup.heightStyles, attrs: { "data-testid": _vm.dataTestid, "tabindex": _setup.tabIndex, "disabled": _vm.disabled, "aria-disabled": _vm.disabled, "to": _vm.to, "target": _vm.target, "external": _vm.external }, on: { "click": _setup.handleClick } }, _setup.v2Listeners), [_vm._t("content", function() {
    return [_c("div", { class: _setup.$style.data, style: _setup.computedStyle }, [_vm.checkbox ? _c("div", { on: { "click": function($event) {
      $event.preventDefault();
    } } }, [_c(_setup.XCheckbox, _vm._b({ attrs: { "prevent-focus": true, "disable-form": "", "data-testid": _setup.formatTestId("checkbox"), "disabled": _vm.disabled } }, "XCheckbox", _setup.listItemCheckboxProps, false))], 1) : _vm._e(), _vm.icon ? _c(_setup.XIcon, { attrs: { "icon": _vm.icon, "icon-style": _vm.iconStyle, "data-testid": _setup.formatTestId("icon") } }) : _vm._e(), _c(_setup.XEllipsis, { class: _setup.$style.text, attrs: { "visible-lines": _vm.ellipsis ? 1 : 0 } }, [_vm._t("default")], 2)], 1), _vm._t("badge", null, { "badgeClass": _setup.$style.badge })];
  })], 2);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XListItem = __component__.exports;
export {
  VALID_TAGS,
  XListItem as default
};
